// eslint-disable-next-line no-restricted-globals
const StringIsNumber = (value: string | number) => !isNaN(Number(value));

// { GET = 0, POST = 1 } -> { 0: 'GET', 1: 'POST' }
export const enumToString = (
  enumType: Record<string | number, string | number>,
): Record<string | number, string | number> =>
  Object.assign(
    {},
    ...Object.keys(enumType)
      .filter(StringIsNumber)
      .map((key: string | number) => ({ [key]: enumType[key].toString() })),
  );

// { GET = 0, POST = 1 } -> [0, 1]
export const enumToList = (enumType: Record<string | number, string | number>): (string | number)[] =>
  Object.keys(enumType)
    .filter(StringIsNumber)
    .map((key: string | number) => key);

type ExtractEnumValueType = {
  <E extends Record<string, string>>(enumeration: E, value: string): E[keyof E] | undefined;
  <E extends Record<string, string>>(enumeration: E, value: string, defaultValue: E[keyof E]): E[keyof E];
};
export const extractEnumValue: ExtractEnumValueType = <E extends Record<string, string>>(
  enumeration: E,
  value: string,
  defaultValue?: E[keyof E],
) => (Object.values(enumeration).includes(value) ? (value as E[keyof E]) : defaultValue);
